import { toast } from "sonner";
import { buildShareEverywhere, copyShare, type ShareTarget } from "@/lib/share/shareEverywhere";
import { recordWarRoomEvent } from "@/lib/warRoom/warRoomEngine";
import { bumpMission } from "@/lib/ambassadors/ambassadorEngine";

/**
 * Compact 4-col grid of the channels creators actually use.
 * For copy-only channels (TikTok / Reels / Discord) we copy the message
 * to the clipboard and then open the channel's upload/home page.
 */
export function ShareEverywhereGrid({
  url,
  message,
}: { url: string; message: string }) {
  const targets = buildShareEverywhere(url, message);

  const onClick = async (t: ShareTarget) => {
    recordWarRoomEvent("shares");
    bumpMission("share_3_clips");
    if (t.copyOnly) {
      const ok = await copyShare(url, message);
      toast.success(ok ? `Copiado — pega en ${t.label}` : `Abre ${t.label} y pega el link`);
      if (t.href) window.open(t.href, "_blank", "noopener,noreferrer");
      return;
    }
    if (t.href) window.open(t.href, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="grid grid-cols-4 gap-2">
      {targets.map((t) => (
        <button
          key={t.id}
          onClick={() => onClick(t)}
          className="flex flex-col items-center gap-1 rounded-xl border border-border/60 bg-background/70 px-2 py-2 text-[10px] font-bold uppercase tracking-wider active:scale-95"
          aria-label={`Share to ${t.label}`}
        >
          <span className="text-lg leading-none">{t.emoji}</span>
          <span>{t.label}</span>
        </button>
      ))}
    </div>
  );
}